/* fdp-product.js (T4b): the product page. Registers main-product (gallery, ticket, tier strip, swatches, size
   chips, sticky bar, design-lab links) and product-price-table (the board) with FDP.core.onSection.
   A port of the approved mockup's product view (mockup/page.html): the same state ({ci, q, method, spots, ...})
   and the same text. Every price string comes from FDP.price (view() returns exactly what gen-price.liquid
   printed, so the page reads the same before and after this script). Fails closed (PLAN 6.6): when a color's
   variant price minus the "from" decoration is not its cheapest size price, or the tables' hash differs from the
   server-rendered one, every price is hidden and "Price this in the design lab, or call ..." shows instead.
   No product form, nothing is ever added to a cart. A ?variant= link opens on that color (2026-10-28).
   2026-10-28: ten quantity breaks (the strip is two rows of five, the track's ticks read 1k / 2.5k / 5k and
   stagger if they would touch), quantities up to 10,000 (FDP.price.clampQty), the big-order lines (the [shipping]
   promise turns into the shipping-quote sentence at data-fdp-ship-quote pieces, the needed-by line shows at
   data-fdp-big pieces), the swatches are one Tab stop with arrow keys between them (roving tabindex), and when the
   sticky bar slides in over the focused element, that element is scrolled clear of it (WCAG 2.4.11). */
(function () {
  "use strict";
  if (window.FDP && window.FDP.product) return;
  var FDP = window.FDP = window.FDP || {};
  var core = FDP.core;
  if (!core) return;

  var PAGE = null;     // the product page's model, set by main-product
  var VIEWS = [];      // price-table renderers [{root, render}]
  var LONG_PRESS = 450;

  function attr(el, k) { return el.getAttribute(k); }
  function show(el, on) { if (el) { if (on) el.removeAttribute("hidden"); else el.setAttribute("hidden", ""); } }
  function pressed(list, pick) { list.forEach(function (b) { b.setAttribute("aria-pressed", String(pick(b))); }); }
  function plural(n, one, many) { return n === 1 ? one : many; }

  function renderViews() { VIEWS.forEach(function (v) { try { v.render(); } catch (e) { setTimeout(function () { throw e; }); } }); }

  // ------------------------------------------------------------------ gallery (every product, priced or not)
  function wireGallery(el, cleanups) {
    var main = el.querySelector("[data-fdp-gal]");
    if (!main) return null;
    var g = { main: main, idx: 0, keys: [], timer: null };
    g.track = function () { return main.querySelector(".gal-track"); };
    g.refresh = function () {     // read the slides now in the DOM
      g.keys = core.$$(".gal-slide", main).map(function (s) { return attr(s, "data-v"); });
      if (g.idx >= g.keys.length) g.idx = 0;
      var dots = el.querySelector("[data-fdp-galdots]");
      if (dots) {
        if (dots.children.length !== g.keys.length) dots.innerHTML = g.keys.map(function () { return "<i></i>"; }).join("");
        show(dots, g.keys.length > 1);
      }
      g.mark();
    };
    g.mark = function () {
      var key = g.keys[g.idx];
      pressed(core.$$("[data-view-btn]", el), function (b) { return attr(b, "data-view-btn") === key; });
      var dots = el.querySelector("[data-fdp-galdots]");
      if (dots) Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle("on", k === g.idx); });
    };
    g.go = function (key, smooth) {
      var k = g.keys.indexOf(key);
      if (k < 0) k = 0;
      g.idx = k;
      var t = g.track();
      if (t) {
        var left = k * t.clientWidth;
        if (smooth && !core.reduced() && t.scrollTo) t.scrollTo({ left: left, behavior: "smooth" });
        else t.scrollLeft = left;
      }
      g.mark();
      if (g.onview) g.onview(g.keys[g.idx]);
    };
    g.align = function () { var t = g.track(); if (t) t.scrollLeft = g.idx * t.clientWidth; };
    function onScroll(e) {
      if (!e.target.classList || !e.target.classList.contains("gal-track")) return;
      clearTimeout(g.timer);
      g.timer = setTimeout(function () {
        var t = g.track();
        if (!t || !t.clientWidth) return;
        var k = Math.max(0, Math.min(g.keys.length - 1, Math.round(t.scrollLeft / t.clientWidth)));
        if (k !== g.idx) { g.idx = k; g.mark(); if (g.onview) g.onview(g.keys[k]); }
      }, 90);
    }
    main.addEventListener("scroll", onScroll, true);
    var onResize = function () { g.align(); };
    window.addEventListener("resize", onResize);
    cleanups.push(function () { main.removeEventListener("scroll", onScroll, true); window.removeEventListener("resize", onResize); clearTimeout(g.timer); });
    g.refresh();
    return g;
  }

  // ------------------------------------------------------------------ main-product
  core.onSection("main-product", function (root) {
    var el = root.querySelector("[data-fdp-product]");
    if (!el) return;
    var cleanups = [];
    var gal = wireGallery(el, cleanups);
    var priced = attr(el, "data-fdp-priced") === "true";

    // Old listings: photos only. A click on a thumb shows its photo.
    if (!priced || !FDP.price || !FDP.sample) {
      var onClickOld = function (e) {
        var b = e.target.closest ? e.target.closest("[data-view-btn]") : null;
        if (b && gal) gal.go(attr(b, "data-view-btn"), true);
      };
      el.addEventListener("click", onClickOld);
      core.$$("[data-fdp-galdots]", el).forEach(function (d) { show(d, gal && gal.keys.length > 1); });
      if (priced) failClosedStatic(root);   // priced, but the engine never loaded
      return function () { el.removeEventListener("click", onClickOld); cleanups.forEach(function (f) { f(); }); };
    }

    var price = FDP.price, sample = FDP.sample;
    price.load();                                 // a theme-editor reload brings a fresh #fdp-prices
    var size = core.json("fdp-size", root) || {};
    var colors = core.json("fdp-colors", root) || [];
    var variants = core.json("fdp-variants", root) || [];
    // Each color's back photo (2026-10-28): the product image whose alt ends in " in <color>, back" (fdp-backs). The
    // first color keeps the back the server picked (its own, or the old single "<title>, back").
    var backs = core.json("fdp-backs", root) || [];
    variants.forEach(function (v) {
      if (!v || v.back) return;
      var want = " in " + v.n + ", back";
      for (var k = 0; k < backs.length; k++) {
        var b = backs[k];
        if (b && typeof b.a === "string" && typeof b.u === "string" && b.a.slice(-want.length) === want) {
          v.back = b.u; v.bw = b.w; v.bh = b.h; return;
        }
      }
    });
    var embOnly = attr(el, "data-fdp-emb-only") === "true";
    var fromDeco = parseInt(attr(el, "data-fdp-from-deco"), 10);
    var kind = sample.kindFor(attr(el, "data-fdp-area"));
    var sampleOn = attr(el, "data-fdp-sample") === "true";
    var sleeveOn = attr(el, "data-fdp-sleeve") === "true";
    var nouns = attr(el, "data-fdp-nouns") || "pieces";
    var label = attr(el, "data-fdp-label") || "";
    var handle = attr(el, "data-fdp-handle");
    var front = Math.max(1, Math.min(3, parseInt(attr(el, "data-fdp-front"), 10) || 2));
    var info = {}, sizeOf = {};
    colors.forEach(function (c) { if (c && c.n != null) info[c.n] = c; });
    (size.colors || []).forEach(function (c) { if (c && c.n != null) sizeOf[c.n] = c; });

    var S = { ci: 0, q: 50, method: embOnly ? "emb" : "print", spots: [front, 0, 0], nn: "none", size: "small", sample: true, view: "front" };

    // ---- the fail-closed checks (PLAN 6.6)
    var boardsV = core.$$("[data-fdp-board]").map(function (b) { return attr(b, "data-fdp-v"); });
    var vOk = price.ready && !!price.v && attr(el, "data-fdp-v") === price.v &&
      boardsV.every(function (v) { return v === price.v; });
    function okColor(ci) {
      var v = variants[ci], sc = v && sizeOf[v.n];
      if (!v || !sc || !Array.isArray(size.sizes) || !Array.isArray(sc.p) || !isFinite(fromDeco)) return false;
      var b = price.basePrice(size.sizes, sc.p);
      return isFinite(b) && Math.round(v.cents) - fromDeco === Math.round(b * 100);
    }
    function gpOf(ci) { return (variants[ci].cents - fromDeco) / 100; }
    function hexOf(ci) { var c = info[variants[ci] && variants[ci].n]; return (c && c.h) || "#888888"; }

    var model = PAGE = {
      root: root, el: el, S: S, embOnly: embOnly, nouns: nouns, label: label, failed: false, vOk: vOk,
      variant: function () { return variants[S.ci]; },
      state: function (extra) {
        var v = variants[S.ci], o = { gp: gpOf(S.ci), embOnly: embOnly, method: S.method, spots: S.spots.slice(), size: S.size, q: S.q,
          nouns: nouns, color: v ? v.n : "", nn: S.nn };
        if (extra) Object.keys(extra).forEach(function (k) { o[k] = extra[k]; });
        return o;
      },
      groups: function () { var v = variants[S.ci], sc = v && sizeOf[v.n]; return sc && size.sizes ? price.sizeGroups(size.sizes, sc.p) : []; },
      // the sizes the "from" garment price covers: the cheapest size group (PLAN 6.4), e.g. "S–XL"
      baseLabel: function () {
        var g = model.groups();
        if (!g.length) return "";
        var lo = Math.min.apply(null, g.map(function (x) { return x.price; }));
        return g.filter(function (x) { return x.price === lo; })[0].label;
      }
    };

    // ---- elements
    var $ = function (s) { return el.querySelector(s); };
    var qty = $("[data-fdp-qty]");
    var hint = qty ? document.getElementById(attr(qty, "aria-describedby")) : null;
    if (hint && !hint.getAttribute("data-orig")) hint.setAttribute("data-orig", hint.textContent);
    var sticky = root.querySelector("[data-fdp-sticky]");

    function dec() { return S.method === "emb" ? { method: "emb", size: S.size } : { method: "print", spots: S.spots.slice() }; }
    function nnD() { return S.method === "print" ? price.nnAt(S.nn) : 0; }

    function setFailed(on) {
      model.failed = on;
      el.setAttribute("data-fdp-failed", on ? "1" : "0");
      [root].concat(VIEWS.map(function (v) { return v.root; })).forEach(function (r) {
        core.$$("[data-fdp-price-ui]", r).forEach(function (x) { show(x, !on); });
        core.$$("[data-fdp-fail]", r).forEach(function (x) { show(x, on); });
      });
      if (on) setSticky(false);
      else if (stickyCheck) stickyCheck();     // back from a failed color: the bar may show again
    }

    // ---- the sticky bar. While it is up, <html> carries .fdp-sticky-on and --fdp-sticky-h (its height), so
    // fdp-product.css keeps the footer's last row (the Light / Dark / Auto toggle) clear of it and keyboard focus
    // scrolls clear of it too (scroll-padding).
    var htmlEl = document.documentElement;
    function stickyH() { if (sticky && sticky.offsetHeight) htmlEl.style.setProperty("--fdp-sticky-h", sticky.offsetHeight + "px"); }
    function setSticky(on) {
      if (!sticky || sticky.classList.contains("show") === on) return;
      sticky.classList.toggle("show", on);
      htmlEl.classList.toggle("fdp-sticky-on", on);
      if (on) { stickyH(); focusClear(); focusSoon(); }
    }
    // WCAG 2.4.11 (focus not obscured): the bar can slide in over the element that has keyboard focus. Shift+Tab
    // from the top lands on the footer's last button: the browser starts a smooth scroll there, the bar shows on
    // the way (the main button scrolls away), and the scroll ends with the button under the bar, because the
    // scroll-padding that keeps focus clear of the bar only applies from then on. So when the bar shows, and
    // again once scrolling has settled after a focus change (within 2 s of it), a focused element outside the
    // bar that overlaps where the bar rests is scrolled into view ("nearest", which honours that scroll-padding).
    // The bar's resting box comes from offsetTop / offsetHeight, which ignore its slide-in transform. Plain
    // scrolling with the wheel or a finger never moves the page: only a recent focus change arms the check.
    var focusAt = 0, focusT = 0;
    function focusSoon() { clearTimeout(focusT); focusT = setTimeout(focusClear, 160); }
    function onFocusMove() { focusAt = Date.now(); focusSoon(); }
    document.addEventListener("focusin", onFocusMove);
    cleanups.push(function () { document.removeEventListener("focusin", onFocusMove); clearTimeout(focusT); });
    function focusClear() {
      var a = document.activeElement;
      if (!sticky || !sticky.classList.contains("show")) return;
      if (!a || a === document.body || a === htmlEl || sticky.contains(a) || !a.getBoundingClientRect) return;
      var r = a.getBoundingClientRect();
      if (!r.width && !r.height) return;
      var top = sticky.offsetTop, bottom = top + sticky.offsetHeight;
      if (r.bottom > top && r.top < bottom) {
        try { a.scrollIntoView({ block: "nearest", inline: "nearest" }); } catch (e) { a.scrollIntoView(false); }
      }
    }

    // ---- the design-lab links follow every ticket change (CONTRACT 11.5)
    function labHref() {
      var v = variants[S.ci], p = { style: handle, color: v ? v.n : "", qty: S.q, method: S.method };
      if (S.method === "emb") p.size = S.size;
      else { p.front = S.spots[0]; p.back = S.spots[1]; if (sleeveOn) p.sleeve = S.spots[2]; p.nn = S.nn; }
      return core.labUrl(p);
    }

    // ---- the quantity track (mockup renderTrack). Ticks at every break, evenly spaced; 1,000 and up read 1k, 2.5k,
    // 5k. If two tick labels would touch (a narrow phone), every other label drops to a second line (.stagger).
    var tickText = function (n) { return n >= 1000 ? (n / 1000) + "k" : String(n); };
    function renderTrack() {
      var tr = $("[data-fdp-track]");
      if (!tr) return;
      var notches = price.T.tiers.map(function (t) { return t.min; }), top = notches[notches.length - 1] * 1.25;
      var xs = notches.concat([top]), step = 100 / (xs.length - 1);
      var pos = function (q) {
        if (q >= top) return 100;
        for (var i = 0; i < xs.length - 1; i++) if (q < xs[i + 1]) return step * (i + Math.max(0, q - xs[i]) / (xs[i + 1] - xs[i]));
        return 100;
      };
      tr.innerHTML = '<span class="rail"></span><span class="fill" style="width:' + pos(S.q) + '%"></span>' +
        notches.map(function (n, k) {
          return '<span class="notch" style="left:' + pos(n) + '%"></span><span class="tl' + (k % 2 ? " lo" : "") + '" style="left:' + pos(n) + '%">' + tickText(n) + "</span>";
        }).join("");
      show(tr, true);
      fitTicks(tr);
    }
    function fitTicks(tr) {
      tr = tr || $("[data-fdp-track]");
      if (!tr || tr.hasAttribute("hidden")) return;
      tr.classList.remove("stagger");
      var tl = core.$$(".tl", tr), clash = false;
      for (var i = 1; i < tl.length && !clash; i++) {
        var a = tl[i - 1].getBoundingClientRect(), b = tl[i].getBoundingClientRect();
        if (a.width && b.width && b.left < a.right + 5) clash = true;
      }
      tr.classList.toggle("stagger", clash);
    }
    var onTrackResize = function () { fitTicks(); };
    window.addEventListener("resize", onTrackResize);
    cleanups.push(function () { window.removeEventListener("resize", onTrackResize); });

    // ---- gallery slides for the current color (the sample prints in the colors being priced)
    var VIEW_LABEL = { front: "Front", back: "Back", close: "Close-up" };   // the server's labels (locale) win
    core.$$("[data-view-btn]", el).forEach(function (b) { var sp = b.querySelector("span"); if (sp) VIEW_LABEL[attr(b, "data-view-btn")] = sp.textContent; });
    var small = function (u) { return String(u).replace(/([?&])width=\d+/, "$1width=160"); };
    function renderGallery() {
      if (!gal) return;
      var v = variants[S.ci];
      if (!v || !v.img) return;
      var light = sample.light(hexOf(S.ci));
      var emb = S.method === "emb";
      var showSample = sampleOn && S.sample && !!kind;
      var name = label + " in " + v.n;
      var frontN = emb ? 3 : S.spots[0];
      var slides = [["front", v.img, sample.photoWithSample(v.img, kind, light, frontN, showSample, name + ", front", { width: v.w || 1000, height: v.h || 1250 })]];
      if (v.back) slides.push(["back", v.back, sample.photoWithSample(v.back, kind, light, emb ? 0 : S.spots[1], showSample, name + ", back",
        { width: v.bw || 1000, height: v.bh || 1250, loading: "lazy" })]);
      if (kind) slides.push(["close", v.img, '<div class="gal-zoom"><div class="gal-zin k-' + kind + '">' +
        sample.photoWithSample(v.img, kind, light, frontN, true, "Close-up of " + name, { width: v.w || 1000, height: v.h || 1250, loading: "lazy" }) + "</div></div>"]);
      var keys = slides.map(function (s) { return s[0]; });
      if (keys.indexOf(S.view) < 0) S.view = "front";
      gal.track().innerHTML = slides.map(function (s) { return '<div class="gal-slide" data-v="' + s[0] + '">' + s[2] + "</div>"; }).join("");
      var th = $("[data-fdp-thumbs]");      // thumbs: the same views, this color's photos
      if (th) th.innerHTML = slides.map(function (s) {
        return '<button type="button" data-view-btn="' + s[0] + '" aria-pressed="' + (s[0] === S.view) + '"><img src="' + core.esc(small(s[1])) +
          '" width="160" height="200" alt=""><span>' + core.esc(VIEW_LABEL[s[0]]) + "</span></button>";
      }).join("");
      gal.refresh();
      gal.idx = Math.max(0, keys.indexOf(S.view));
      gal.align();
      gal.mark();
    }
    if (gal) gal.onview = function (key) { S.view = key; };

    // ---- swatch tooltips: "Black · $11.70 at 50" (JS only)
    function renderTips() {
      var d = dec(), nn = nnD();
      core.$$("[data-fdp-fams] .sw", el).forEach(function (b) {
        var k = +attr(b, "data-ci"), v = variants[k], tip = b.querySelector(".tip");
        if (!tip || !v) return;
        var each = okColor(k) && model.vOk ? price.eachAt(gpOf(k) + nn, d, S.q) : NaN;
        tip.textContent = isFinite(each) ? v.n + " · " + price.money(each) + " at " + price.qtyText(S.q) : v.n;
      });
    }

    // ---- everything that follows the state
    var shipQ = parseInt(attr(el, "data-fdp-ship-quote"), 10) || 0, bigQ = parseInt(attr(el, "data-fdp-big"), 10) || 0;
    function bigOrder() {
      var quote = shipQ > 0 && S.q >= shipQ;
      core.$$("[data-fdp-ship]", el).forEach(function (li) {
        show(li.querySelector("[data-fdp-ship-std]"), !quote);
        show(li.querySelector("[data-fdp-ship-quote]"), quote);
      });
      core.$$("[data-fdp-bigorder]", el).forEach(function (x) { show(x, bigQ > 0 && S.q >= bigQ); });
    }
    function update(user) {
      var v = variants[S.ci];
      bigOrder();
      var good = model.vOk && okColor(S.ci) && isFinite(price.eachAt(gpOf(S.ci) + nnD(), dec(), S.q));
      setFailed(!good);
      var colorLbl = $("[data-fdp-colorlbl]");
      if (colorLbl && v) colorLbl.textContent = "Color: " + v.n + " · " + variants.length + " " + plural(variants.length, "color", "colors");
      core.$$("[data-fdp-lablink]", root).forEach(function (a) { a.setAttribute("href", labHref()); });
      if (!good) { renderTips(); return; }
      var st = model.state(), d = dec(), g = price.c2(st.gp + nnD());
      var each = price.eachAt(g, d, S.q), total = price.c2(each * S.q);
      var words = price.decoWords(d, S.method === "print" ? S.nn : "none");
      var head = $("[data-fdp-headline]");
      if (head) head.innerHTML = price.view("headline", st);
      var strip = $("[data-fdp-strip]");
      if (strip) strip.innerHTML = price.view("strip", st);
      var tk = function (k) { return $('[data-fdp-tk="' + k + '"]'); };
      if (tk("terms")) tk("terms").textContent = label + " · " + v.n + " · " + words;
      if (tk("each")) tk("each").innerHTML = price.money(each) + " <small>each</small>";
      if (tk("total")) tk("total").textContent = price.qtyText(S.q) + " pieces · " + price.money(total);
      var cl = $("[data-fdp-cliff]");
      if (cl) { var c = price.view("cliff", st); cl.innerHTML = c; show(cl, !!c); }
      // fine print: this color's sizes (JS only: Liquid can't read the size table)
      var groups = model.groups();
      var fs = $("[data-fdp-finesize]");
      if (fs) { fs.textContent = groups.length ? v.n + ", sizes " + model.baseLabel() + ". " : ""; show(fs, groups.length > 0); }
      // size chips: the garment price of each size group + the same decoration
      var ti = price.tierOf(S.q), chips = $("[data-fdp-sizes]");
      if (chips) {
        chips.innerHTML = groups.map(function (x) {
          return "<span><b>" + core.esc(x.label) + "</b>" + price.money(price.c2(x.price + nnD() + price.decoAt(d, ti))) + "</span>";
        }).join("");
        show($("[data-fdp-sizesline]"), groups.length > 0);
      }
      renderTrack();
      renderTips();
      if (sticky) {
        var dot = sticky.querySelector("[data-fdp-stdot]"), sp = sticky.querySelector("[data-fdp-stprice]"), stt = sticky.querySelector("[data-fdp-stterms]");
        if (dot) dot.style.background = hexOf(S.ci);
        if (sp) sp.textContent = price.money(each) + " each";
        if (stt) stt.textContent = price.qtyText(S.q) + " · " + words + " · " + label + " · " + v.n;
      }
      if (user) {
        core.sweep($("[data-fdp-sq]"));
        core.announce(price.money(each) + " each, " + price.qtyText(S.q) + " pieces, " + price.money(total) + " total");
      }
      renderViews();
    }
    model.update = update;

    // ---- the ticket's own controls
    function setQty(val, fromTyping) {
      var n = Math.floor(+val || 0);
      var lo = price.minQty();
      if (n < lo) {
        n = lo;
        if (hint) { hint.classList.add("warn"); hint.textContent = "The minimum is " + lo + " pieces. Mix any garments to get there."; }
      } else if (hint && hint.classList.contains("warn")) {
        hint.classList.remove("warn"); hint.textContent = attr(hint, "data-orig") || hint.textContent;
      }
      n = price.clampQty(n);           // min..10,000: the 5,000+ break is reachable (2026-10-28)
      if (qty && (!fromTyping || String(n) !== qty.value)) qty.value = n;
      S.q = n;
      update(true);
    }
    function spotText(n) { return n ? n + " " + plural(n, "color", "colors") : "None"; }
    function syncTicket() {
      var emb = S.method === "emb";
      pressed(core.$$("[data-m]", el), function (b) { return attr(b, "data-m") === S.method; });
      core.$$("[data-fdp-fields]", el).forEach(function (f) { show(f, attr(f, "data-fdp-fields") === (emb ? "emb" : "print")); });
      core.$$("[data-fdp-fine]", el).forEach(function (f) { show(f, attr(f, "data-fdp-fine") === (emb ? "emb" : "print")); });
      core.$$("[data-fdp-spout]", el).forEach(function (o) { o.textContent = spotText(S.spots[+attr(o, "data-fdp-spout")]); });
      pressed(core.$$("[data-nn]", el), function (b) { return attr(b, "data-nn") === S.nn; });
      pressed(core.$$("[data-es]", el), function (b) { return attr(b, "data-es") === S.size; });
      var eh = $("[data-fdp-eshint]");
      if (eh) eh.textContent = attr(eh, S.size === "large" ? "data-large" : "data-small") || eh.textContent;
      sampleWords();
    }
    // the sample's toggle label and caption: "printed in the colors you price" for screen print; the embroidery
    // words (every thread color shows, thread colors aren't priced) for embroidery
    function sampleWords() {
      var k = S.method === "emb" ? "data-emb" : "data-print";
      core.$$("[data-fdp-smplbl], [data-fdp-galcap]", el).forEach(function (x) { var t = attr(x, k); if (t) x.textContent = t; });
    }
    function pickColor(ci) {
      if (!variants[ci]) return;
      S.ci = ci;
      pressed(core.$$("[data-fdp-fams] .sw", el), function (b) { return +attr(b, "data-ci") === ci; });
      rove();
      renderGallery();
      update(true);
    }

    // ---- swatches: one Tab stop (the pressed swatch), arrow keys move between all of them across the families,
    // Home / End jump to the ends, Enter / Space pick (they are buttons). Clicks and aria-pressed are unchanged.
    var swatchList = function () { return core.$$("[data-fdp-fams] .sw", el); };
    function rove(to) {
      var list = swatchList();
      if (!list.length) return;
      if (!to) to = list.filter(function (b) { return attr(b, "aria-pressed") === "true"; })[0] || list[0];
      list.forEach(function (b) { b.tabIndex = b === to ? 0 : -1; });
    }
    function onSwatchKey(e) {
      var b = e.target.closest ? e.target.closest("[data-fdp-fams] .sw") : null;
      if (!b) return false;
      var list = swatchList(), k = list.indexOf(b), n = list.length, to = -1;
      if (e.key === "ArrowRight" || e.key === "ArrowDown") to = (k + 1) % n;
      else if (e.key === "ArrowLeft" || e.key === "ArrowUp") to = (k - 1 + n) % n;
      else if (e.key === "Home") to = 0;
      else if (e.key === "End") to = n - 1;
      if (to < 0) return false;
      e.preventDefault();
      rove(list[to]);
      list[to].focus();
      placeTip(list[to]);
      return true;
    }
    function onSwatchOut(e) {
      var fams = el.querySelector("[data-fdp-fams]");
      if (fams && fams.contains(e.target) && !(e.relatedTarget && fams.contains(e.relatedTarget))) rove();
    }

    // long-press shows a swatch's tooltip on touch screens (no selection); placeTip keeps it on screen
    var lp = { timer: null, fired: false, hideT: null, btn: null };
    function placeTip(b) {
      var tip = b && b.querySelector(".tip");
      if (!tip) return;
      tip.style.transform = "";
      var r = tip.getBoundingClientRect();
      if (!r.width) return;
      var vw = document.documentElement.clientWidth, dx = 0;
      if (r.right > vw - 8) dx = vw - 8 - r.right;
      if (r.left + dx < 8) dx = 8 - r.left;
      if (dx) tip.style.transform = "translateX(calc(-50% + " + Math.round(dx) + "px))";
    }
    function hideTip() { if (lp.btn) lp.btn.classList.remove("tip-on"); lp.btn = null; }
    function onDown(e) {
      var b = e.target.closest ? e.target.closest("[data-fdp-fams] .sw") : null;
      if (!b || e.pointerType === "mouse") return;
      clearTimeout(lp.timer); lp.fired = false;
      lp.timer = setTimeout(function () {
        lp.fired = true; hideTip(); lp.btn = b; b.classList.add("tip-on"); placeTip(b);
        clearTimeout(lp.hideT); lp.hideT = setTimeout(hideTip, 1800);
      }, LONG_PRESS);
    }
    function onUp() { clearTimeout(lp.timer); }
    function onOver(e) {
      var b = e.target.closest ? e.target.closest("[data-fdp-fams] .sw") : null;
      if (b) placeTip(b);
    }
    function onCtx(e) { if (e.target.closest && e.target.closest("[data-fdp-fams] .sw")) e.preventDefault(); }

    function onClick(e) {
      var t = e.target;
      if (!t.closest) return;
      var b;
      if ((b = t.closest("[data-fdp-fams] .sw"))) {
        if (lp.fired) { lp.fired = false; e.preventDefault(); return; }
        pickColor(+attr(b, "data-ci")); return;
      }
      if ((b = t.closest("[data-step]"))) { setQty((+qty.value || price.minQty()) + +attr(b, "data-step")); return; }
      if ((b = t.closest("[data-tmin]"))) { setQty(+attr(b, "data-tmin")); return; }
      if ((b = t.closest("[data-to]"))) { setQty(+attr(b, "data-to")); if (qty) qty.focus(); return; }
      if ((b = t.closest("[data-m]"))) {
        S.method = embOnly || attr(b, "data-m") === "emb" ? "emb" : "print";
        if (S.method === "print" && !S.spots[0] && !S.spots[1] && !S.spots[2]) S.spots = [1, 0, 0];
        syncTicket(); renderGallery(); update(true); return;
      }
      if ((b = t.closest("[data-es]"))) { S.size = attr(b, "data-es") === "large" ? "large" : "small"; syncTicket(); update(true); return; }
      if ((b = t.closest("[data-nn]"))) { S.nn = attr(b, "data-nn"); syncTicket(); update(true); return; }
      if ((b = t.closest("[data-sp]"))) {
        var k = +attr(b, "data-sp"), v = Math.max(0, Math.min(6, S.spots[k] + +attr(b, "data-d")));
        if (v === 0 && !S.spots.some(function (x, j) { return j !== k && x > 0; })) v = 1;   // at least one printed spot
        S.spots[k] = v; syncTicket(); renderGallery(); update(true); return;
      }
      if ((b = t.closest("[data-view-btn]"))) { S.view = attr(b, "data-view-btn"); if (gal) gal.go(S.view, true); return; }
      if ((b = t.closest("[data-fdp-sampletoggle] [data-v]"))) {
        S.sample = attr(b, "data-v") === "1";
        pressed(core.$$("[data-fdp-sampletoggle] [data-v]", el), function (x) { return x === b; });
        renderGallery(); return;
      }
    }
    function onChange(e) { if (e.target === qty) setQty(qty.value, true); }
    function onKey(e) {
      if (e.target === qty && e.key === "Enter") { setQty(qty.value, true); return; }
      onSwatchKey(e);
    }

    el.addEventListener("click", onClick);
    el.addEventListener("change", onChange);
    el.addEventListener("keydown", onKey);
    el.addEventListener("pointerdown", onDown);
    el.addEventListener("pointerup", onUp);
    el.addEventListener("pointercancel", onUp);
    el.addEventListener("pointermove", function (e) { if (lp.timer && e.pointerType !== "mouse" && Math.abs(e.movementX || 0) + Math.abs(e.movementY || 0) > 6) clearTimeout(lp.timer); });
    el.addEventListener("mouseover", onOver);
    el.addEventListener("focusin", onOver);
    el.addEventListener("focusout", onSwatchOut);
    el.addEventListener("contextmenu", onCtx);
    cleanups.push(function () {
      el.removeEventListener("click", onClick); el.removeEventListener("change", onChange); el.removeEventListener("keydown", onKey);
      el.removeEventListener("pointerdown", onDown); el.removeEventListener("pointerup", onUp); el.removeEventListener("pointercancel", onUp);
      el.removeEventListener("mouseover", onOver); el.removeEventListener("focusin", onOver); el.removeEventListener("contextmenu", onCtx);
      el.removeEventListener("focusout", onSwatchOut);
      clearTimeout(lp.timer); clearTimeout(lp.hideT);
    });

    // ---- sticky bar: shows once the main button has scrolled away, above the screen (none without #mainCta).
    // The observer catches normal scrolling; a jump straight past the button (the End key, a restored scroll
    // position, a fast fling) never makes it intersect, so a rAF-throttled scroll check covers those too.
    var cta = document.getElementById("mainCta");
    if (sticky && cta && root.contains(cta)) {
      var stickyCheck = function () { var r = cta.getBoundingClientRect(); setSticky(!model.failed && r.bottom <= 0 && r.height > 0); };
      var raf = 0;
      var onStickyScroll = function () {
        if (!raf) raf = requestAnimationFrame(function () { raf = 0; stickyCheck(); });
        if (Date.now() - focusAt < 2000) focusSoon();   // a focus scroll is still running: check once it settles
      };
      var onStickyResize = function () { if (sticky.classList.contains("show")) stickyH(); onStickyScroll(); };
      var io = "IntersectionObserver" in window ? new IntersectionObserver(stickyCheck, { threshold: 0 }) : null;
      if (io) io.observe(cta);
      window.addEventListener("scroll", onStickyScroll, { passive: true });
      window.addEventListener("resize", onStickyResize);
      cleanups.push(function () {
        if (io) io.disconnect();
        if (raf) cancelAnimationFrame(raf);
        window.removeEventListener("scroll", onStickyScroll, { passive: true });
        window.removeEventListener("resize", onStickyResize);
        htmlEl.classList.remove("fdp-sticky-on");
        htmlEl.style.removeProperty("--fdp-sticky-h");
      });
    }

    // ---- first paint: JS-only bits appear, and the server text is re-rendered (identical for this state).
    // A ?variant= link (the collection cards link to the color they show, 2026-10-28) opens on that color; an id
    // that isn't one of this product's colors is ignored.
    core.$$("[data-fdp-sampletoggle], [data-fdp-galcap]", el).forEach(function (x) { show(x, sampleOn && !!kind); });
    sampleWords();
    (function () {
      var id = null;
      try { id = new URLSearchParams(window.location.search).get("variant"); } catch (e) { id = null; }
      if (!id || !/^\d+$/.test(id)) return;
      for (var i = 1; i < variants.length; i++) {
        if (variants[i] && String(variants[i].id) === id) {
          S.ci = i;
          pressed(core.$$("[data-fdp-fams] .sw", el), function (b) { return +attr(b, "data-ci") === i; });
          return;
        }
      }
    })();
    rove();
    renderGallery();
    update(false);

    return function () {
      cleanups.forEach(function (f) { f(); });
      if (PAGE === model) PAGE = null;
    };
  });

  // Priced page, but fdp-price.js / fdp-sample.js never ran: no price may stay on screen.
  function failClosedStatic(root) {
    core.$$("[data-fdp-price-ui]").forEach(function (x) { show(x, false); });
    core.$$("[data-fdp-fail]").forEach(function (x) { show(x, true); });
    var el = root.querySelector("[data-fdp-product]");
    if (el) el.setAttribute("data-fdp-failed", "1");
  }

  // ------------------------------------------------------------------ product-price-table (P13)
  core.onSection("product-price-table", function (root) {
    var board = root.querySelector("[data-fdp-pt]");
    if (!board) return;
    var embOnly = attr(board, "data-fdp-emb-only") === "true";
    var B = { tab: embOnly ? "emb" : "print", col: { print: 1, emb: 1 }, more: false };
    var $ = function (s) { return root.querySelector(s); };

    function layout() {
      pressed(core.$$("[data-ptab]", root), function (b) { return attr(b, "data-ptab") === B.tab; });
      core.$$("[data-fdp-boardwrap]", root).forEach(function (w) { show(w, attr(w, "data-fdp-boardwrap") === B.tab); });
      core.$$("[data-fdp-colseg]", root).forEach(function (s) {
        var mine = attr(s, "data-fdp-colseg");
        show(s, mine === B.tab);
        pressed(core.$$("[data-col]", s), function (b) { return +attr(b, "data-col") === B.col[mine]; });
      });
      var kindEl = $("[data-fdp-capkind]");
      if (kindEl) kindEl.textContent = attr(kindEl, B.tab === "emb" ? "data-emb" : "data-print") || kindEl.textContent;
      var mb = $("[data-fdp-more]");
      if (mb) { show(mb, B.tab === "print"); mb.textContent = attr(mb, B.more ? "data-hide" : "data-show"); mb.setAttribute("aria-expanded", String(B.more)); }
      core.$$(".ptable", root).forEach(function (t) {
        t.classList.toggle("more", B.more && attr(t, "data-fdp-board") === "print");
        var sel = B.col[attr(t, "data-fdp-board")] || 1;
        core.$$("th.c, td.c", t).forEach(function (c) {      // the selected column (only it shows on phones)
          var idx = Array.prototype.indexOf.call(c.parentNode.children, c);
          c.classList.toggle("sel", idx === sel);
        });
      });
    }

    function render() {
      var P = PAGE, price = FDP.price;
      if (!P || !price || !price.ready || P.failed) { layout(); return; }
      var v = P.variant();
      if (!v) return;
      var w = $('[data-fdp-boardwrap="print"]');
      if (w) w.innerHTML = price.view("board-print", P.state({ sel: B.col.print }));
      w = $('[data-fdp-boardwrap="emb"]');
      if (w) w.innerHTML = price.view("board-emb", P.state({ method: "emb", sel: B.col.emb }));
      var fn = $("[data-fdp-footnote]");
      if (fn) fn.innerHTML = price.view("footnote", P.state());
      var cn = $("[data-fdp-capname]");
      if (cn) cn.textContent = P.label + " · " + v.n;
      var cs = $("[data-fdp-capsize]"), groups = P.groups();
      if (cs) { cs.textContent = groups.length ? " · " + P.baseLabel() : ""; show(cs, groups.length > 0); }
      layout();
    }

    function onClick(e) {
      var t = e.target, b;
      if (!t.closest) return;
      if ((b = t.closest("[data-ptab]"))) { B.tab = attr(b, "data-ptab") === "emb" ? "emb" : "print"; layout(); return; }
      if ((b = t.closest("[data-col]"))) { var s = b.closest("[data-fdp-colseg]"); B.col[attr(s, "data-fdp-colseg")] = +attr(b, "data-col"); layout(); return; }
      if ((b = t.closest("[data-fdp-more]"))) { B.more = !B.more; layout(); return; }
    }
    root.addEventListener("click", onClick);

    // a board rendered by the server with other tables than this page's fails the page closed
    var price = FDP.price;
    if (price && price.ready && PAGE) {
      var bad = core.$$("[data-fdp-board]", root).some(function (b) { return attr(b, "data-fdp-v") !== price.v; });
      if (bad) PAGE.vOk = false;
    }
    var view = { root: root, render: render };
    VIEWS.push(view);
    if (PAGE && PAGE.update) PAGE.update(false); else render();
    return function () {
      root.removeEventListener("click", onClick);
      VIEWS = VIEWS.filter(function (x) { return x !== view; });
    };
  });

  FDP.product = { page: function () { return PAGE; } };
})();
